// extracted by mini-css-extract-plugin
module.exports = {"root":"MonthRangeSwitch_root__2F2cs","range":"MonthRangeSwitch_range__37Y7i","disabled":"MonthRangeSwitch_disabled__nPcS_"};